module.exports = __webpack_public_path__ + "static/media/coach_member_icon.c2cb38c2.svg";